export const InputChipsDefaultProps = {
  value: [],
  disableBackspaceChipRemove: false,
  separatorCode: 'Space'
};